import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { capitalizeLetter } from "../ProjectLog/LogHelpers";

const STATUS_PALETTE = {
  FAIL: {
    color: "#b00020",
    bg: "rgba(176, 0, 32, 0.1)",
    border: "rgba(176, 0, 32, 0.2)",
  },
  PAUSED: {
    color: "#ed6c02",
    bg: "rgba(237, 108, 2, 0.1)",
    border: "rgba(237, 108, 2, 0.2)",
  },
  SUCCESS: {
    color: "#31a633",
    bg: "rgba(49, 166, 51, 0.1)",
    border: "rgba(49, 166, 51, 0.2)",
  },
  SUCCESS_END: {
    color: "#31a633",
    bg: "rgba(49, 166, 51, 0.1)",
    border: "rgba(49, 166, 51, 0.2)",
  },
  INPROGRESS: {
    color: "#ff9d0b",
    bg: "rgba(255, 157, 11, 0.1)",
    border: "rgba(255, 157, 11, 0.2)",
  },
  WAITING: {
    color: "#5d6bc4",
    bg: "rgba(93, 107, 196, 0.1)",
    border: "rgba(93, 107, 196, 0.2)",
  },
  TERMINATED: {
    color: "#b00020",
    bg: "rgba(176, 0, 32, 0.1)",
    border: "rgba(176, 0, 32, 0.2)",
  },
};

const DEFAULT_PALETTE = {
  color: "#666666",
  bg: "rgba(102, 102, 102, 0.1)",
  border: "rgba(102, 102, 102, 0.2)",
};

const GREYED_PALETTE = {
  color: "rgba(156, 163, 175, 1)",
  bg: "rgba(156, 163, 175, 0.1)",
  border: "rgba(156, 163, 175, 0.2)",
};

const STATUS_LABELS = {
  FAIL: "Error",
  INPROGRESS: "In Progress",
};

export const renderStatus = (status, options = {}) => {
  const { asChip = false, isLatestRun = true } = options;
  const palette = isLatestRun
    ? STATUS_PALETTE[status] || DEFAULT_PALETTE
    : GREYED_PALETTE;

  const displayStatus = STATUS_LABELS[status] || status || "";
  const label = capitalizeLetter(String(displayStatus).toLowerCase());

  if (asChip) {
    return (
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
          padding: "4px 10px",
          borderRadius: "6px",
          backgroundColor: palette.bg,
          border: `1px solid ${palette.border}`,
          fontSize: "12px",
          fontWeight: 500,
          color: palette.color,
          lineHeight: 1,
          whiteSpace: "nowrap",
        }}
      >
        {status === "INPROGRESS" && (
          <CircularProgress
            size={12}
            thickness={4}
            sx={{ color: palette.color }}
          />
        )}
        {label}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        color: palette.color,
        fontWeight: "bold",
        fontSize: "13px",
      }}
    >
      {status === "INPROGRESS" && (
        <CircularProgress size={16} style={{ marginRight: "8px" }} />
      )}
      {label}
    </Box>
  );
};
